namespace TabAurous.Retail {
    export namespace POSApprovalReturnBOMService {
        export const baseUrl = 'Retail/POSApprovalReturnBOM';

        export declare function Create(request: Serenity.SaveRequest<POSApprovalReturnBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<POSApprovalReturnBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSApprovalReturnBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<POSApprovalReturnBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Retail/POSApprovalReturnBOM/Create",
            Update = "Retail/POSApprovalReturnBOM/Update",
            Delete = "Retail/POSApprovalReturnBOM/Delete",
            Retrieve = "Retail/POSApprovalReturnBOM/Retrieve",
            List = "Retail/POSApprovalReturnBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>POSApprovalReturnBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
